//SMALL TABLE EXAMPLE 

import React from "react";
import "../assets/css/antd_table_custom-1.0.0.css";
import DataTable from "./DataTable.js";

function SmallDataTable() {
const columns = [
    {
      id: "1",
      title: "Date Column One",
      dataIndex: "dateColumnOne",
      defaultSortOrder: "descend",
      sorter: (a, b) => (a.dateColumnOne > b.dateColumnOne ? -1 : 1),
      selected: true,
      value: "something1"
    },
    {
      id: "2",
      title: "Column Two",
      dataIndex: "columnTwo",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.columnTwo.localeCompare(b.columnTwo),
      selected: true,
      value: "something2"
    },
    {
      id: "3",
      title: "Sample Column Three",
      dataIndex: "sampleColumnThree",
      selected: true,
      value: "something3"
    }
  ];

  const dataSource = [
    {
      key: "1",
      dateColumnOne: "2/28/2022 @ 1:15 PM",
      columnTwo: "AAA",
      sampleColumnThree: "123"
    },
    {
      key: "2",
      dateColumnOne: "3/01/2022 @ 4:45 AM",
      columnTwo: "BBB",
      sampleColumnThree: "456"
    },
    {
      key: "3",
      dateColumnOne: "3/02/2022 @ 12:00 PM",
      columnTwo: "CCC",
      sampleColumnThree: "789"
    }
  ];


  function listItemClick(item) {

  }

  return (
    <div>
      <h2>Small Table Example</h2>

      <hr />
      <DataTable
        dataSource={dataSource}
        columns={columns}
        label={"Requires Review/HICS"}
        onSelect={listItemClick}
        id={"datatable_antd_1"}
        exportCSV={true}
        mobileViewSortEnable={false}
      />
      <hr />
    </div>
  );
}

export default SmallDataTable;